import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import DatePicker from 'react-datepicker';
import { createFirebaseItem } from './firebase-helpers'
import generateShifts from './generate-shifts'
import { pipe, map, contains } from 'ramda'

class CreateRota extends FirebaseComponent {
  constructor() {
		super()

    this.state = {
      startDate: '',
      endDate: '',
      pattern: '',
      momentStartDate: null,
      momentEndDate: null,
      loading: false
    }

    this.handleValueChange = this.handleValueChange.bind(this)
    this.handleStartDateChange = this.handleStartDateChange.bind(this)
    this.handleEndDateChange = this.handleEndDateChange.bind(this)
    this.loadingSpinner = this.loadingSpinner.bind(this)
    this.createRota = this.createRota.bind(this)
  }

  handleValueChange(event) {
    this.setState({[event.target.name]: event.target.value})
  }

  handleStartDateChange(momentStartDate) {
    this.setState({ momentStartDate, startDate: momentStartDate.format() })
  }

  handleEndDateChange(momentEndDate) {
    this.setState({ momentEndDate, endDate: momentEndDate.format() })
  }

  loadingSpinner() {
    if (this.state.loading) return <i className="fa fa-spinner fa-spin" style={{ 'font-size': '24px' }}></i>
  }

  invalidPattern(pattern) {
    const containsNaN = pipe(map(isNaN), contains(true))
    const splitPattern = pattern.split(',')
    if (splitPattern.length % 2 !== 0 || containsNaN(splitPattern)) {
      return true
    }
    return false
  }

  createRota(event) {
    event.preventDefault()
    this.setState({ loading: true })

    if (this.invalidPattern(this.state.pattern)) {
      return this.setState({
        message: 'Invalid pattern. Check pattern rules',
        loading: false
      })
    }

    createFirebaseItem('rotas', {
      account: this.state.uid,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      pattern: this.state.pattern
    }).then(rotaId => {
      generateShifts(rotaId, this.state.startDate, this.state.endDate, this.state.pattern)
        .then(() => {
          this.setState({
            endDate: '',
            pattern: '',
            momentStartDate: null,
            momentEndDate: null,
            loading: false,
            message: ''
          })
        })
    })
  }

  render() {
    return (
      <div>
        <form>
          <div className="form-group">
            <DatePicker
              name="startDate"
              selected={this.state.momentStartDate}
              onChange={this.handleStartDateChange}
              placeholderText="Start Date"
              className="form-control"
            />
            <DatePicker
              name="endDate"
              selected={this.state.momentEndDate}
              onChange={this.handleEndDateChange}
              placeholderText="End Date"
              className="form-control"
            />
            <input
              name="pattern"
              placeholder="Shift Pattern e.g 10,10,5,5 = Ten working, ten off, five working, five off"
              value={this.state.pattern}
              onChange={this.handleValueChange}
              type="text"
              className="form-control" />
          </div>
          <button
            className="btn btn-primary btn-sm btn-block"
            onClick={this.createRota}
            type="submit">{this.loadingSpinner()} CREATE ROTA</button>
          {this.state.message}
        </form>
      </div>
    )
  }
}

export default CreateRota



// WEBPACK FOOTER //
// ./src/CreateRota.js